<template>
	<div class="wh-block">
		<h3>Настройки менталки</h3>
		<div class="settings">
			<table class="uk-table">
				<!--<th v-for="(val, key) in table.rows">{{ key }}</th>-->
				<tr>
					<th></th>
					<th v-for="(c, k) in table[0]">{{ c.target }}</th>
				</tr>
				<tr v-for="(row, r_key) in table">
					<td>{{ r_key }}</td>
					<td v-for="(column, c_key) in row" class="settings__item">
						<div @click="openSettings" class="settings__val">{{ column.value }}</div>
						<div class="settings__active">
							<h4>Ячейка {{ r_key }} - {{ column.target }}</h4>
							<!--<label>
								<span>Значение</span>
								<input type="text" name="value" v-model="column.value" @keyup.enter="closeActive">
							</label>-->
							<h5>Формулы</h5>
							<label>
								<input type="checkbox" value="Прямой счет" v-model="column.allowed">
								<span>Прямой счет</span>
							</label>
							<label>
								<input type="checkbox" value="Формула 1" v-model="column.allowed">
								<span>Формула 1</span>
							</label>
							<label>
								<input type="checkbox" value="Формула 2" v-model="column.allowed">
								<span>Формула 2</span>
							</label>
							<button class="uk-button" @click="closeActive">ОК</button>
						</div>
					</td>
				</tr>
			</table>
			<button class="uk-button uk-margin-top" @click="saveTable">Сохранить</button>
			<div class="uk-margin-top ch_num">
				<input type="text" v-model="v1" placeholder="Число 1">
				<input type="text" v-model="v2" placeholder="Число 2">
				<button class="uk-button" @click="checkNumbers">Проверить</button>
				<div class="ch_num__result" v-if="result">
					<p>Ответ: {{ result.value }}</p>
					<p>Подходит для формул: {{ result.allowed }}</p>
				</div>
			</div>
			<div class="formulas uk-margin-top">
				<input type="text" v-model="userFormula">
				<button class="uk-button" @click="addFormula">Добавить формулу</button>
			</div>
		</div>
	</div>
</template>

<script>
  //import tbl from './table'
  import axios from 'axios'
  export default {
    name: "tableComponent",
    data() {
      return {
        v1: '',
        v2: '',
        result: '',
        table: '',
        trainer: '',
        formulas: '',
	      userFormula: ''
      }
    },
    props: {
      items: ''
    },
    computed: {
      /*table() {
        return this.$store.state.current_trainer.params.table;
      }*/
    },
    methods: {
      checkNumbers() {
        let result = this.findInTable(this.v1, this.v2);
        this.result = result;
      },
      openSettings(e) {
        //console.log(e);
        $('.settings__item').removeClass('active');
        $(e.target).parent().toggleClass('active');
        $(e.target).parent().find('input[name="value"]').focus();
      },
	    addFormula(){
        let f = this.userFormula;
        if(f){
          this.formulas.push(f);
          this.userFormula = '';
        }
	    },
      closeActive() {
        $('.settings__item').removeClass('active');
      },
      saveTable() {
        let table = this.table;
        let formulas = this.formulas;
        let train_id = this.trainer.id;
        let arr = {
          'table': table,
          'train': train_id,
	        'formulas': formulas
        };
        axios.post(window.location.href, arr , {
          headers: {
            'X-OCTOBER-REQUEST-HANDLER': 'onSaveMentalTable',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (res) {
          console.log(res.data);
        });
      },
      findInTable(v1, v2) {
        let table = this.table;
        let result = table[v1].filter(o => o.target == v2)[0];
        return result;
      },
      loadTrainer() {
        let id = 3;
        let app = this;
        axios.post(window.location.href, { id }, {
          headers: {
            'X-OCTOBER-REQUEST-HANDLER': 'onGetMentalTrainer',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (res) {
          console.log(res);
          app.table = res.data.params.table;
          app.formulas = res.data.params.formulas;
          app.trainer = res.data;
        });
      }
    },
    mounted() {
      this.loadTrainer();
      //console.log(this.findInTable(2,4));
      // this.table = tbl;
      /*this.table.forEach(function (row) {
        row.forEach(function (column) {
          console.log(column);
          column.allowed = [];
        })
      });*/
    }
  }
</script>